
seedWebServices.factory('ToastService', ['toasty', function (toasty) {

    var publicContext = {};

//-------------------------------------------------------
//                      METHODS
//-------------------------------------------------------

    publicContext.createToast = function (toastTitle, toastMessage, timeToClose, type) {
        var toastID = null;
        var toastConfig =   {   title: toastTitle,
                                msg: toastMessage,
                                timeout: timeToClose,
                                clickToClose: true,
                                showClose: true,
                                onAdd: function () {
                                    toastID = this.id;
                                }
                            };
        toasty[type](toastConfig);

        return toastID;
    };

    publicContext.createToastSound = function (toastTitle, toastMessage, timeToClose, type) {
        var toastID = null;
        var toastConfig = {
            title: toastTitle,
            msg: toastMessage,
            timeout: timeToClose,
            sound: true,
            clickToClose: true,
            showClose: true,            
            onAdd: function () {
                toastID = this.id;
            }
        };
        toasty[type](toastConfig);

        return toastID;
    };

    publicContext.createToastConnection = function (toastTitle, toastMessage, timeToClose, type) {
        var toastID = null;
        var toastConfig = {
            position: 'top-right',
            title: toastTitle,
            msg: toastMessage,
            timeout: timeToClose,
            clickToClose: true,
            showClose: true,
            onAdd: function () {
                toastID = this.id;
            }
        };
        toasty[type](toastConfig);

        return toastID;
    };

    publicContext.removeToast = function (id) {
        if ((angular.isDefined(id)) && (id !== null)) {
            toasty.clear(id);
        }
    };

    publicContext.clear = function () {
        toasty.clear();
    };

    publicContext.updateToast = function (toastID, toastTitle, toastMessage, timeToClose, type) {
        publicContext.removeToast(toastID);
        publicContext.createToast(toastTitle, toastMessage, timeToClose, type);
    };

    publicContext.getErrorMsg = function (err) {
        var errMsg = '';
        if (err.data) {
            errMsg = err.data.Message;
            errMsg += '\n';            
            errMsg += err.data.ExceptionMessage;
        }
        return errMsg;
    };

    return publicContext;
},

]);
